export const SHEET_NAMES = {
  CHUONG_TRINH_DAO_TAO: 'chuong_trinh_dao_tao_3',
  // sau này thêm tiếp
  // SINH_VIEN: 'sinh_vien',
};